import {Component, Input, OnInit} from '@angular/core';
import {AuthService} from "../../../../shared/services/auth.service";
import {RewardsSummaryService} from "../../../../shared/services/rewards-summary.service";
import {ParamService} from "../../../../shared/services/param.service";
import {properties} from "../../../../../environments/properties";
import {ActivatedRoute, Router} from "@angular/router";

@Component({
    selector: 'app-partner-detail',
    templateUrl: './partner-detail.component.html',
    styleUrls: ['./partner-detail.component.scss']
})
export class PartnerDetailComponent implements OnInit {

    currentEnvironment: string;
    partnerDetails: any;
    userInfo: any;
    appHostURL: any;
    banner: any;
    tokenCaller = 'partners';
    isError = false;
    isPartnerPromotionV2: any;
    selectedBanner: any;
    isLoggedInTokenValid: any;
    tokenObject: any;
    partnerDetailContentURL: any;
    partnerSection: any;
    isWebView: boolean = false;

    public errorMessage: string = "";

    constructor(public authService: AuthService,
                private _rewardSummaryService: RewardsSummaryService,
                private paramService: ParamService, private router: ActivatedRoute, private redirectRouter: Router) {
    }

    ngOnInit(): void {
        this.currentEnvironment = this._rewardSummaryService.getEnvironment();
        this.banner = this.paramService.banner;
        this.isPartnerPromotionV2 = properties.rewardsConfig.partnerPromotionV2[this.banner];
        this.appHostURL = this.authService.getApplicationDomainURL();
        const partnerData = localStorage.getItem('partnerDetails');
        if (partnerData) {
            this.partnerDetails = JSON.parse(partnerData);
            localStorage.removeItem("partnerDetails");
            this.userInfo = this.partnerDetails.userInfo;
            this.getUserInfoV2();
        } else {
            this.redirectToPartnerLandingPage();
        }
    }

    getUserInfoV2() {
        if (this.userInfo) {
            if (this.authService.isTokenValidForSession(this.userInfo)) {
                this.selectedBanner = this.userInfo.banner;
                this.isLoggedInTokenValid = true;
            } else {
                this.redirectToPartnerLandingPage();
            }
        } else {
            this.redirectToPartnerLandingPage();
        }

    }

    redirectToPartnerLandingPage() {
        this.redirectRouter.navigate(['rewards/partners']);
    }

}
